/* eslint-disable @typescript-eslint/no-explicit-any */
import './index.css';

import { LicenseInfo } from '@mui/x-license';
import Bootstrapper from '@witron/asl_core/Bootstrapper';
import BaseModule from '@witron/asl_core/ModuleManager/BaseModule';
import Shell from '@witron/asl_shell/Shell';

LicenseInfo.setLicenseKey(
    'f1c44e52a81a583e313c6628bf331fddTz0xMjQ1OTAsRT0xODAxNzg1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
);

async function importModules(): Promise<Array<BaseModule<any, any>>> {
    const modules: Array<BaseModule<any, any>> = [];

    const shellModules = await Shell.importModules();
    modules.concat(shellModules);

    const importedCore = await import('@witron/asl_core_module/Core/CoreModule');
    modules.push(importedCore.CoreModule.getInstance());

    const importedBWos = await import('@witron/asl_core_module/BWosSo/BWosSoModule');
    modules.push(importedBWos.BWosSoModule.getInstance());

    const importedBMIS = await import('@witron/abl_bmis/BMIS/BMISModule');
    modules.push(importedBMIS.BMISModule.getInstance());

    const importedBI = await import('@witron/abl_bi/BI/BIModule');
    modules.push(importedBI.BIModule.getInstance());

    const importedBGif = await import('@witron/abl_bgif/BGIF/BGIFModule');
    modules.push(importedBGif.BGIFModule.getInstance());

    const importedBWOS = await import('@witron/abl_bwos_module/BWOS/BWosModule');
    modules.push(importedBWOS.BWosModule.getInstance());

    // const importedBPFP = await import('@witron/abl_bpfp/BPFP/BPFPModule');
    // modules.push(importedBPFP.BPFPModule.getInstance());

    return modules;
}

function startUp() {
    void Bootstrapper.startUpStandalone('root', Shell.App, importModules, Shell.importPlugins);
}

window.requestAnimationFrame(startUp);
